<template>
  <div class="index">
    <div class="header dis-flex2">
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="logo dis-flex2">
            <img src="@/assets/img/logo.png" alt srcset />
          </div>
        </el-col>
        <!-- 菜单开始 -->
        <el-col :span="10">
          <ul class="ul dis-flex2">
            <li
              v-for="(item,index) in menu"
              :key="index"
              class="li left pointer"
              @click="hamburger(index)"
            >
              <div class="hamburger margin">
                <img class="img" :src="item.imgUrl" alt srcset />
              </div>
              <p class="tc">{{item.title}}</p>
            </li>
          </ul>
        </el-col>
        <!-- 菜单结束 -->
        <el-col :span="5">
          <div class="grid-content bg-purple"></div>
        </el-col>
      </el-row>
    </div>
    <div class="mian flex1 dis-flex1">
      <div>
        <ul class>
          <li class="left" v-for="(item,index) in ImgArr" :key="index" @click="openFunWin(index)">
            <img class="img" :src="item" alt srcset />
          </li>
        </ul>
      </div>
    </div>
    <div class="bootom">
      <el-row>
        <el-col :span="12">
          <div class="tl secondary">登录用户: {{userInfo['job_number']}} 【{{userInfo['name']}}】</div>
        </el-col>
        <el-col :span="12">
          <div class="tr secondary">当前时间: {{time}}</div>
        </el-col>
      </el-row>
    </div>
    <div class="close pointer">
      <div class="flex closeCen" @click="close()">
        <div>
          <img src="../assets/img/icon/close.png" alt srcset />
        </div>
        <div class="closeCen-p">退出系统</div>
      </div>
      <div class="flex closeCen" @click="dialogVisible = true">
        <div class="closeCen-p">切换账号</div>
      </div>
    </div>
    <!-- 弹出层开始 -->
    <selectionMenu :isShow="isShow" :dataList="dataList"></selectionMenu>
    <!-- 弹出层结束 -->
    <!-- 切换账号开始 -->
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <login></login>
    </el-dialog>
    <!-- 切换账号结束 -->

<!--    <el-dialog title="其他管理" :visible.sync="otherSetting">-->
<!--      <el-row class="other" :gutter="24">-->
<!--        <el-col class="other-item fg" :span="12">返工管理</el-col>-->
<!--        <el-col class="other-item bk" :span="12">补款管理</el-col>-->
<!--      </el-row>-->
<!--    </el-dialog>-->


  </div>
</template>

<script>
import selectionMenu from "@/components/selectionMenu";
import login from "@/components/login";
import { mapGetters } from "vuex";
export default {
  components: {
    selectionMenu: selectionMenu,
    login: login
  },
  data() {
    return {
      isShow: false, //弹出层
      dialogVisible: false, //切换账号弹窗
      dataList: [],
      time: "",
      otherSetting: false,
      ImgArr: [
        require("../assets/img/Enter-factory.png"),
        require("../assets/img/Handle.png"),
        require("../assets/img/Factory.png")
      ],
      menu: [
        {
          imgUrl: require("../assets/img/icon/1.png"),
          title: "打开菜单"
        },
        {
          imgUrl: require("../assets/img/icon/2.png"),
          title: "衣物查询"
        },
        {
          imgUrl: require("../assets/img/icon/3.png"),
          title: "衣物预警"
        },
        {
          imgUrl: require("../assets/img/icon/4.png"),
          title: "业绩查询"
        },
        {
          imgUrl: require("../assets/img/icon/5.png"),
          title: "掉标管理"
        },
        {
            imgUrl: require("../assets/img/icon/6.png"),
            title: "其他管理"
        }
      ]
    };
  },
  created() {
    setInterval(() => {
      this.time = new Date().toLocaleString();
    }, 1000);
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    close() {
      this.$confirm("即将退出程序, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        nw.App.quit();
      });
    },
    // 点击菜单
    hamburger(index) {
      switch (index) {
        case 0:
          this.dataList = [{ title: "出厂查询", url: "exitFactory" }];
          this.isShow = !this.isShow;
          break;
        case 1:
          this.$nw.openWin("/clothingInquiries");
          break;
        case 2:
          this.$nw.openWin("/productionEarlyWarning");
          break;
        case 3:
          this.$nw.openWin("/workload");
          break;
        case 4:
          this.$nw.openWin("/dropMark");
          break;
        case 5:
            this.dataList = [
                { title: "返工管理", url: "rework" },
                { title: "补款管理", url: "compensation" },
                { title: "营业额管理", url: "StoreTurnover" },
                { title: "收衣统计", url: "Statistics" },
                { title: "总检查询", url: "checkClothCount" }
            ];
            this.isShow = !this.isShow;
          break;
        default:
          break;
      }
    },
    async openFunWin(code) {
      let res = await this.$http.operate(code + 1);
      switch (code) {
        case 0:
          res.map((v, i) => {
            res[i].url = "enterFactory";
          });
          this.dataList = res;
          break;
        case 1:
          res.map((v, i) => {
            res[i].url = "enterFactory";
          });
          this.dataList = res;
          break;
        case 2:
          res.map((v, i) => {
            res[i].url = "factory";
          });
          this.dataList = res;
          break;
        default:
          break;
      }
      this.isShow = !this.isShow;
    },
    // 切换账号关闭
    handleClose(done) {
      done();
    }
  }
};
</script>
<style lang="less">
@import "../assets/less/view/index.less";
</style>